import React, { Component, Fragment } from 'react';
import { Row, Col, Button, Card } from 'antd';
import { withAsyncActions } from 'react-async-client';
import { Field } from 'formik';
import yup from 'yup';

import { projects } from 'constants/routes';
import { patchProject, postProject } from 'actions/asyncActions';
import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import withForm from 'components/hocs/withForm';
import Input from 'components/common/form/Input';
import Text from 'components/common/form/Text';
import Date from 'components/common/form/Date';
import Select from 'components/common/form/Select';

const validationSchema = yup.object({
    name: yup.string().required().matches(/^[а-яА-ЯЁё -]*$/, 'Допустимы только кириллические буквы'),
    project_type: yup.string().required(),
    region_id: yup.number().required(),
    locality_type: yup.string().required(),
    locality_name: yup.string().required(),
    house_number: yup.string().required(),
    housing_number: yup.string().nullable(),
    apartment_number: yup.string().nullable(),
    description: yup.string().required(),
    finishing_date: yup.string().date().nullable(),
});

@withAutoFocusForm
@withAsyncActions(({ isEdit, getProjectId }) => ({
    formAction: (isEdit ? patchProject : postProject)
        .withSuccessHandler((paylod, { history }) => {
            if(isEdit) return history.push(projects.stringify());
            getProjectId(paylod.formAction.data.project_id)
        }),
}))
@withForm({
    validationSchema,
})
export default class ProjectForm extends Component {
    render() {

        const { project_id } = this.props

        return (
            <Fragment>
                <Card title="Информация о проекте" bordered={false} className="card-fixed">
                    <Row gutter={20}>
                        <Col className="form" md={24}>
                            <Row gutter={20}>
                                <Col xs={24} sm={15}>
                                    <Field
                                        name='name'
                                        component={Input}
                                        placeholder='Название проекта'
                                    />
                                </Col>
                                <Col xs={24} sm={9}>
                                    <Field
                                        name='project_type'
                                        component={Input}
                                        placeholder='Тип проекта'
                                    />
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col xs={24} className="form-label">
                                    Адрес
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col xs={24}>
                                    <Field
                                        showSearch
                                        name='region_id'
                                        value={this.props.initialValues.region_id ? this.props.initialValues.region.name : this.props.values.region_id}
                                        component={Select}
                                        optionFilterProp="children"
                                        filterOption={(inputValue, option) => option.props.children.indexOf(inputValue) !== -1}
                                        placeholder='Регион'
                                        dictionary='regions'
                                    />
                                </Col>
                                <Col xs={24} sm={24}>
                                    <Field
                                        name='locality_type'
                                        component={Select}
                                        dictionary='locality_type'
                                        placeholder='Тип населенного пункта'
                                    />
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col xs={24} sm={15}>
                                    <Field
                                        name='locality_name'
                                        component={Input}
                                        placeholder='Населенный пункт, Улица'
                                    />
                                </Col>
                                <Col xs={8} sm={3}>
                                    <Field
                                        name='house_number'
                                        component={Input}
                                        placeholder='Дом'
                                    />
                                </Col>
                                <Col xs={8} sm={3}>
                                    <Field
                                        name='housing_number'
                                        component={Input}
                                        placeholder='Корпус'
                                    />
                                </Col>
                                <Col xs={8} sm={3}>
                                    <Field
                                        name='apartment_number'
                                        component={Input}
                                        placeholder='Квартира'
                                    />
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col xs={24} sm={24} className="form-label">
                                    Ориентировочная дата закупки оборудования
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col xs={24} sm={15}>
                                    <Field
                                        name='finishing_date'
                                        component={Date}
                                        placeholder='Выберете дату'
                                        disabledDate='past'
                                    />
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col xs={24} className="form-label">
                                Описание проекта
                                </Col>
                            </Row>
                            <Row gutter={20}>
                                <Col xs={24}>
                                    <Field
                                        name='description'
                                        component={Text}
                                        placeholder='Краткое описание'
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
                <Row className="controls" gutter={20}>
                    <Col xs={24}>
                        <Button 
                            type="primary sm-l-m-20" 
                            htmlType="submit" 
                            disabled={project_id ? true : false}
                            style={{ opacity: project_id ? 0.5 : 1 }}
                            title={project_id ? "Проект уже создан, добавьте заявку." : ""}
                            >
                            Сохранить
                        </Button>
                    </Col>
                </Row>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/projects/project/ProjectForm.js